import { oc } from '@orpc/contract';
import { runDetailSchema, updateRunMeasurementsInputSchema } from '../schemas/runs.schemas.js';
export const updateRunMeasurementsContract = oc
    .route({
    method: 'PATCH',
    path: '/runs/{id}/measurements',
    tags: ['Runs'],
    summary: 'Record what was measured during and after a draft run',
    description: 'Only while the run is DRAFT. An absent field is left alone; an explicit null clears it.',
})
    .input(updateRunMeasurementsInputSchema)
    .output(runDetailSchema);
//# sourceMappingURL=update-run-measurements.contract.js.map